










































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import { bngState, setDefaultProgram } from '@/services/browse-and-go/store'

@Component({
  name: 'BrowseAndGoBenefits',
  components: { PageHeader }
})
export default class extends Vue {
  get programs() {
    return bngState.programs
  }

  private open(id: string) {
    this.$router.push({ name: 'BrowseAndGoBenefitEdit', params: { id } })
  }

  private makeDefault(id: string) {
    setDefaultProgram(id)
    this.$message.success('Modèle de Programme Avantages défini par défaut')
  }
}
